import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { b2cInHouseFinanceApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${b2cInHouseFinanceApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
